// import login and home
import Application from './components/Application.vue';
import DirectApplication from './components/DirectApplication.vue';

// set routes
export const routes = [
  {
    path: '/',
    component: Application,
  },
  {
    path: '/ur',
    component: DirectApplication,
  }
];
